<template>
  <v-dialog
    width="680px"
    persistent
    scrollable
    v-model="isOpened"
  >
    <v-card>
      <v-card-title>
        Nouveau compte-rendu d'intervention
        <v-spacer />
        <v-btn icon @click="isOpened = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <template v-if="interventionId">
        <v-card-text class="pa-12" v-if="isFetchingIntervention">
          <v-row no-gutters justify="center" align="center">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6"
              style="max-width: 200px;"
            />
          </v-row>
        </v-card-text>
        <v-card-text class="pt-4 pb-6 px-6" v-else>
          <v-row no-gutters justify="center" align="start">
            <v-icon color="accent">outlined_flag</v-icon>
            <v-col class="ml-4">
              <div class="font-weight-medium text-subtitle-1 pb-1">
                Demande initiale
              </div>
              <n-card depressed v-html="intervention.$htmlDescription" class="px-4 py-3 primary--text" />
            </v-col>
          </v-row>
          <v-row no-gutters justify="center" align="start" class="pt-2">
            <v-icon color="accent">business</v-icon>
            <v-col class="ml-4">
              <div class="font-weight-medium text-subtitle-1 pb-1">
                Site concerné
              </div>
              <div class="font-weight-bold text-subtitle-1 primary--text">
                {{ intervention.site.name }}
                <span v-if="intervention.$sitePostalCodeAndCity.length">&nbsp;- {{ intervention.$sitePostalCodeAndCity }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters justify="center" align="center" class="pt-6">
            <v-col cols="6" class="pr-2">
              <v-row no-gutters justify="center" align="start">
                <v-col>
                  <div class="primary--text">
                    <v-select
                      v-model="reportStatusId"
                      :items="statuses"
                      item-value="id"
                      item-text="name"
                      label="Statut après intervention"
                      placeholder="--"
                      persistent-placeholder
                      hide-details
                      outlined
                      :loading="isFetchingStatuses"
                      :disabled="isFetchingStatuses"
                    >
                      <template #prepend-inner>
                        <v-icon color="accent" class="mr-2">label</v-icon>
                      </template>
                      <template #selection="{ item }">
                        <div style="max-width: 100%">
                          <v-chip
                            :color="item.color"
                            class="font-weight-medium text-center"
                            :style="{
                              color: item.fontColor,
                            }"
                          >
                            <div
                              class="px-3"
                              style="overflow: hidden; text-overflow: ellipsis;"
                            >
                              {{ item.name }}
                            </div>
                          </v-chip>
                        </div>
                      </template>
                      <template #item="{ item }">
                        <div style="max-width: 100%">
                          <v-chip
                            :color="item.color"
                            class="font-weight-medium text-center"
                            :style="{
                              color: item.fontColor,
                            }"
                          >
                            <div
                              class="px-3"
                              style="overflow: hidden; text-overflow: ellipsis;"
                            >
                              {{ item.name }}
                            </div>
                          </v-chip>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" class="pl-2">
              <v-row no-gutters justify="center" align="start">
                <v-col>
                  <div class="primary--text">
                    <v-select
                      v-model="reportUserId"
                      :items="users"
                      item-value="id"
                      item-text="name"
                      label="Intervenant"
                      placeholder="--"
                      persistent-placeholder
                      hide-details
                      outlined
                      :loading="isFetchingUsers"
                      :disabled="isFetchingUsers"
                    >
                      <template #prepend-inner>
                        <v-icon color="accent" class="mr-2">engineering</v-icon>
                      </template>
                    </v-select>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters justify="center" align="center" class="pt-6">
            <v-col cols="6" class="pr-2">
              <v-row no-gutters justify="center" align="start">
                <v-col class="pr-1">
                  <v-menu
                    ref="menu"
                    v-model="dateMenu"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateFormatted"
                        label="Date"
                        outlined
                        readonly
                        hide-details
                        v-bind="attrs"
                        v-on="on"
                      >
                        <template #prepend-inner>
                          <v-icon color="accent" class="mr-2">event</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      :first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="pl-1" style="max-width: 140px;">
                  <v-select
                    v-model="hour"
                    :items="dayHours"
                    label="Heure"
                    outlined
                    hide-details
                    menu-props="auto"
                  >
                    <template #prepend-inner>
                      <v-icon color="accent" class="mr-2">schedule</v-icon>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" class="pl-2">
              <v-row no-gutters justify="center" align="center">
                <v-col>
                  <v-text-field
                    v-model="durationHours"
                    type="number"
                    label="Durée (heures)"
                    placeholder=""
                    persistent-placeholder
                    hide-details
                    outlined
                  >
                    <template #prepend-inner>
                      <v-icon color="accent" class="mr-2">hourglass_bottom</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
                <div class="px-1 font-weight-bold text-subtitle-1 primary--text">:</div>
                <v-col>
                  <v-text-field
                    v-model="durationMinutes"
                    type="number"
                    label="Durée (minutes)"
                    placeholder=""
                    persistent-placeholder
                    hide-details
                    outlined
                  >
                    <template #prepend-inner>
                      <v-icon color="accent" class="mr-2">hourglass_bottom</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters justify="center" align="start" class="pt-6">
            <v-col>
              <v-row no-gutters justify="center" align="start">
                <v-col>
                  <v-text-field
                    v-model="interlocutorName"
                    label="Interlocuteur chez le client"
                    placeholder=""
                    persistent-placeholder
                    hide-details
                    outlined
                  >
                    <template #prepend-inner>
                      <v-icon color="accent" class="mr-2">person</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters justify="center" align="start" class="pt-6">
            <v-col>
              <v-textarea
                v-model="description"
                label="Compte-rendu de l'intervention *"
                placeholder="Détails de votre intervention..."
                persistent-placeholder
                no-resize
                hide-details
                outlined
                height="300"
                :error="isDescriptionError"
              >
                <template #prepend-inner>
                  <v-icon color="accent" class="mr-2">rate_review</v-icon>
                </template>
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </template>

      <v-divider />
      <v-card-actions class="px-5 py-3">
        <v-spacer></v-spacer>
        <v-btn text @click="isOpened = false" class="mr-4" v-if="!isCreatingReport">Annuler</v-btn>
        <v-btn
          type="submit"
          :loading="isCreatingReport"
          color="primary darken-1"
          class="px-4"
          @click="createReport"
        >
          Créer ce compte-rendu
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import dayHours from '@/dayHours.js';

export default {
  props: {
    value: Boolean,
    interventionId: {
      type: Number,
      required: false,
    },
  },

  data: () => ({
    isFetchingIntervention: false,
    isFetchingStatuses: true,
    isFetchingUsers: true,
    isCreatingReport: false,
    isDescriptionError: false,
    dayHours,
    reportUserId: null,
    reportStatusId: null,
    dateMenu: null,
    date: null,
    hour: ``,
    durationHours: 0,
    durationMinutes: 0,
    description: ``,
    interlocutorName: ``,
  }),

  computed: {
    ...mapState(`model/user`, [
      `me`,
    ]),
    ...mapGetters(`ui/interventionReportAdd`, [
      `intervention`,
      `statuses`,
      `users`,
    ]),
    ...mapState(`model/user`, [
      `isMakerUser`,
      `isSelfMakerUser`,
    ]),
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
    dateFormatted() {
      if (!this.date) {
        return ``;
      }
      return moment(this.date, `YYYY-MM-DD`).format(`DD/MM/YYYY`);
    },
  },

  methods: {
    ...mapMutations(`ui/interventionReportAdd`, {
      setInterventionId: `SET_INTERVENTION_ID`,
    }),
    ...mapActions(`ui/interventionReportAdd`, {
      storeFetchIntervention: `fetchIntervention`,
      storeFetchStatuses: `fetchStatuses`,
      storeFetchUsers: `fetchUsers`,
      storeCreateReport: `createReport`,
    }),
    async fetchIntervention() {
      this.isFetchingIntervention = true;
      await this.storeFetchIntervention();
      this.isFetchingIntervention = false;
    },
    async fetchStatuses() {
      this.isFetchingStatuses = true;
      await this.storeFetchStatuses();
      this.reportStatusId = this.intervention.Status_id;
      this.isFetchingStatuses = false;
    },
    async fetchUsers() {
      this.isFetchingUsers = true;
      await this.storeFetchUsers();
      this.reportUserId = this.intervention.Assignee_id;
      if (!this.reportUserId && this.findUserByIdInList(this.me.id)) {
        this.reportUserId = this.me.id;
      }
      this.isFetchingUsers = false;
    },
    findUserByIdInList(userId) {
      return _.find(this.users, { id: userId });
    },
    setTodayDate() {
      this.date = moment().format(`YYYY-MM-DD`);
    },
    setNearestHour() {
      this.hour = moment().startOf(`hour`).format(`HH:mm`);
    },
    async createReport() {
      if (this.isCreatingReport) { return; }

      let durationHours = parseInt(this.durationHours, 10);
      let durationMinutes = parseInt(this.durationMinutes, 10);

      if (!_.isInteger(durationHours)) { durationHours = 0; }
      if (!_.isInteger(durationMinutes)) { durationMinutes = 0; }


      const description = _.trim(this.description);
      const date = moment(`${this.date} ${this.hour}`, `YYYY-MM-DD HH:mm`).format(`YYYYMMDDHHmm`);
      const duration = durationHours * 60 + durationMinutes;
      const interlocutorName = _.trim(this.interlocutorName);

      this.isDescriptionError = description.length === 0;

      if (this.isDescriptionError) { return; }

      this.isCreatingReport = true;

      const report = await this.storeCreateReport({
        description,
        date,
        duration,
        interlocutorName,
        User_id: this.reportUserId,
        Status_id: this.reportStatusId,
      });

      if (report) {
        this.$emit(`created`, report);
      }

      this.isCreatingReport = false;
    },
  },

  async beforeMount() {
    this.setInterventionId(this.interventionId);
    this.setTodayDate();
    this.setNearestHour();
    await this.fetchIntervention();
    this.fetchStatuses();
    this.fetchUsers();
  },

  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.isCreatingReport = false;
      }
    },
    description(description) {
      this.isDescriptionError = _.trim(description).length === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
